var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2489 9.15137C19.7175 9.62 19.7175 10.3798 19.2489 10.8484L10.8489 19.2484C10.3803 19.7171 9.62049 19.7171 9.15186 19.2484L0.751863 10.8484C0.517511 10.6141 0.400353 10.3069 0.400391 9.99976V3.9999C0.400391 2.01168 2.01217 0.399902 4.00039 0.399902H10.0007C10.3077 0.399986 10.6147 0.517143 10.8489 0.751374L19.2489 9.15137ZM4.00039 5.1999C4.66313 5.1999 5.20039 4.66264 5.20039 3.9999C5.20039 3.33716 4.66313 2.7999 4.00039 2.7999C3.33765 2.7999 2.80039 3.33716 2.80039 3.9999C2.80039 4.66264 3.33765 5.1999 4.00039 5.1999Z",
    fill: "#00AF50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagGreen);
export default __webpack_public_path__ + "static/media/TagGreen.29e29df48b52ffe25aa79a7fab8102b2.svg";
export { ForwardRef as ReactComponent };